import * as React from 'react';

import {ClassNameBuilder} from '../../../utils/ClassNameBuilder';

import Styles from './Radio.module.scss';

interface Props {
    disabled?: boolean;
    defaultChecked?: boolean;
    name?: string;
    color?: string;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    className?: string;
}

export const Radio: React.FC<Props> = (props) => {
    const {color, defaultChecked, disabled, name, onChange, className} = props;

    const containerClass = new ClassNameBuilder(Styles, 'radio')
        .add([className, !!className])
        .toString();

    return (
        <label className={containerClass}>
            <input type="radio"
                defaultChecked={!!defaultChecked}
                disabled={!!disabled}
                name={name}
                onChange={(event) => onChange && onChange(event)}
            />
            <div className={Styles['radio-mock']} style={{borderColor: color || 'var(--color-text)'}}/>
        </label>
    );
};
